export default __webpack_public_path__ + "static/media/scan.78d2a635.gif";